import { createContext, useContext } from 'react';
import type { AuthStatus, AuthUser, GlobalRole } from './types';

export interface AuthContextValue {
  status: AuthStatus;
  /** Dane uzytkownika odczytane z tokena. `null`, gdy nikt nie jest zalogowany. */
  user: AuthUser | null;
  isAuthenticated: boolean;

  /** Identyfikator sesji nadany przy logowaniu (naglowek `X-Session-Id`). */
  sessionId: string | null;
  /** Moment wygasniecia biezacego tokena dostepu. */
  accessTokenExpiresAt: Date | null;

  /** Loguje uzytkownika. Rzuca `ApiError`, gdy dane sa nieprawidlowe. */
  login: (email: string, password: string, rememberMe: boolean) => Promise<void>;
  /** Wylogowuje i uniewaznia sesje po stronie serwera. */
  logout: () => Promise<void>;

  /**
   * Sprawdza role uzytkownika. `ADMIN` przechodzi kazda kontrole — tak samo
   * jak w serwisach backendu.
   *
   * To WYLACZNIE sterowanie interfejsem. Realne uprawnienia egzekwuje backend.
   */
  hasRole: (...roles: GlobalRole[]) => boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

/** Dostep do stanu uwierzytelnienia. Rzuca poza `AuthProvider`. */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth musi być użyte wewnątrz AuthProvider.');
  }
  return context;
}
